export const saveLocalStorageData = (key: string, data: any): void => {
	localStorage.setItem(key, JSON.stringify(data));
};

export const readLocalStorageData = (key: string): any => {
	const data = localStorage.getItem(key);
	return data ? JSON.parse(data) : null;
};

export const deleteLocalStorageData = (key: string): void => localStorage.removeItem(key);
